import { observer } from 'owa-mobx-react';
import React from 'react';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { getDensityModeString, getDensityModeCssClass } from 'owa-fabric-theme';

import {
    skeletonContainer,
    firstRow,
    firstRowGap,
    firstRowLine,
    secondRow,
    personaCircle,
    personaGap,
    secondRowText,
    secondRowMainLine,
    secondRowGap,
    secondRowEndLine,
    secondRowEndGap,
    thirdRow,
    thirdRowGap,
    thirdRowLine,
    full,
    compact,
    paddingFirstMessage,
    paddingMessage,
    mailListShimmerContainer,
} from './ShimmerRowThreeColV9.scss';

import classnames from 'owa-classnames';

export interface ShimmerRowThreeColV9Props {
    isFirstMessage: boolean;
}

const ShimmerRowThreeColV9: React.FunctionComponent<ShimmerRowThreeColV9Props> = observer(
    function ShimmerRowThreeColV9(props: ShimmerRowThreeColV9Props) {
        const densityModeString = getDensityModeString();
        const showCircle = densityModeString === 'full';

        return (
            <div
                className={classnames(
                    getDensityModeCssClass(full, undefined, compact),
                    props.isFirstMessage ? paddingFirstMessage : paddingMessage,
                    mailListShimmerContainer
                )}
            >
                <Skeleton className={skeletonContainer}>
                    {/* First row: gap + short line */}
                    <div className={firstRow}>
                        <div className={firstRowGap} />
                        <SkeletonItem className={firstRowLine} size={16} />
                    </div>

                    {/* Second row: persona circle + text with end element */}
                    <div className={secondRow}>
                        <div className={personaCircle}>
                            <div className={personaGap} />
                            {showCircle && <SkeletonItem shape="circle" size={28} />}
                        </div>
                        <div className={secondRowText}>
                            <SkeletonItem className={secondRowMainLine} size={16} />
                            <div className={secondRowGap} />
                            <SkeletonItem className={secondRowEndLine} size={16} />
                            <div className={secondRowEndGap} />
                        </div>
                    </div>

                    {/* Third row: gap + medium line */}
                    <div className={thirdRow}>
                        <div className={thirdRowGap} />
                        <SkeletonItem className={thirdRowLine} size={16} />
                    </div>
                </Skeleton>
            </div>
        );
    },
    'ShimmerRowThreeColV9'
);

export default ShimmerRowThreeColV9;
